module.exports = __webpack_public_path__ + "static/media/pincil-thankyou.5b5a578c.png";